import { SingleTierTax } from './../../classes/singleTierTax/singleTierTax';
import { TierRate } from '../../interfaces';
import { ArbeidsKortingConfig } from './interface';
import { rates } from './config';

export class ArbeidsKorting {
    
    tax: number;
    
    constructor(data: ArbeidsKortingConfig) {
        const property = data.senior ? 'senior' : 'nonSenior';
        const ratesForYear: TierRate[] = rates[property][data.year];

        this.tax = new SingleTierTax(ratesForYear, data.income).tax;
    }
    
}
